<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P3rHR4/tc-custom/cover.jpg?1703128560990" alt="This image is the cover for the book The Book of the Thousand Nights and a Night — Volume 02, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Book of the Thousand Nights and a Night — Volume 02, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>The Book of the Thousand Nights and a Night (1885), is a celebrated English language translation of One Thousand and One Nights (the “Arabian Nights”) – a collection of Middle Eastern and South Asian stories and folk tales compiled in Arabic during the Islamic Golden Age (8th−13th centuries) – by the British explorer and Arabist Richard Francis Burton (1821–1890). (Excerpt from Wikipedia)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard F. Burton
      </h2>
      
      <p class="authorDescription body article">Sir Richard Francis Burton; (19 March 1821 – 20 October 1890) was an English explorer, geographer, translator, writer, soldier, orientalist, cartographer, ethnologist, spy, linguist, poet, fencer, and diplomat. He was famed for his travels and explorations in Asia, Africa and the Americas, as well as his extraordinary knowledge of languages and cultures. According to one count, he spoke 29 European, Asian and African languages. Burton's best-known achievements include a well-documented journey to Mecca, in disguise at a time when Europeans were forbidden access on pain of death; an unexpurgated translation of One Thousand and One Nights (commonly called The Arabian Nights in English after early translations of Antoine Galland's French version); the publication of the Kama Sutra in English; and a journey with John Hanning Speke as the first Europeans to visit the Great Lakes of Africa in search of the source of the Nile. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Adelaide Library
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?410d0350